import { render, staticRenderFns } from "./input-date-range-picker.vue?vue&type=template&id=f2895c8e&scoped=true&"
import script from "./input-date-range-picker.vue?vue&type=script&lang=js&"
export * from "./input-date-range-picker.vue?vue&type=script&lang=js&"
import style0 from "./input-date-range-picker.vue?vue&type=style&index=0&id=f2895c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2895c8e",
  null
  
)

export default component.exports